import { IncentivePage } from "./IncentivePage";

export const Incentive = () => {
	return <IncentivePage />;
};
